import { SYSTEM_COLORS } from "../../../../components/system.colors";

export const SectionTitle = ({ title, description, style }) => (
  <hgroup style={{ marginBlockEnd: "1.2rem", ...style }}>
    <div style={{ display: "flex", alignItems: "center", gap: "0.6rem" }}>
      <span style={{ inlineSize: "4px", blockSize: "1.1rem", borderRadius: "2px", background: SYSTEM_COLORS.ORANGE.DEEP_ORANGE, flexShrink: 0 }} />
      <h6 style={{ margin: 0, fontSize: "1.05rem", fontWeight: 700, color: SYSTEM_COLORS.BLACK.EERIE_BLACK }}>
        {title}
      </h6>
    </div>

    {description && (
      <p style={{ fontSize: "0.78rem", color: SYSTEM_COLORS.GRAY.GREY, margin: "0.4rem 0 0 1rem", maxInlineSize: "56rem" }}>
        {description}
      </p>
    )}
  </hgroup>
);
